import { gql } from '@apollo/client';

export const allBreedsQuery = gql`
  query NANO_RegisterChipV2_allBreeds($species: Species) {
    allBreeds(species: $species) {
      ...breed
    }
  }

  fragment breed on Breed {
    id
    name
    species
  }
`;
